import React from 'react';
import {Link} from "react-router-dom";

const CustomPagination = ({rowCount, currentPageSize, currentPage, handlePageChange, maxPage, actualDataLength}) => {
    // Use maxPage from API if available, otherwise calculate from rowCount
    const pageCount = maxPage ? Math.max(1, maxPage) : Math.max(1, Math.ceil((rowCount || 0) / (currentPageSize || 10)));
    
    // Gerçekte gösterilen kayıt sayısını hesapla
    const displayedCount = actualDataLength || Math.min(currentPageSize, rowCount || 0);

    const generatePageNumbers = () => {
        const pageNumbers = [];
        const maxVisiblePages = 5; // Kaç sayfa numarasını göstermek istediğinizi ayarlayın

        for (let i = 1; i <= pageCount; i++) {
            if (
                i === 1 ||
                i === pageCount ||
                (i >= currentPage - Math.floor(maxVisiblePages / 2) &&
                    i <= currentPage + Math.floor(maxVisiblePages / 2))
            ) {
                pageNumbers.push(i);
            }
        }

        return pageNumbers;
    };

    const renderDots = () => {
        return (
            <span className="page-link">...</span>
        );
    };

    return (
        <div className="row">
            <div className="col-sm-6 d-flex justify-content-start">

                {rowCount >= 20 ? (
                    <div className="text-muted">
                        Showing <span className="fw-semibold">{displayedCount}</span> of <span className="fw-semibold">{rowCount}</span>.
                    </div>
                ) : (
                    <div className="text-muted">
                        <span className="fw-semibold">{rowCount}</span> results.
                    </div>
                )}

            </div>
            <div className="col-sm-6 d-flex justify-content-end">
                <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
                    <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                        <Link to="#" className="page-link" onClick={(e) => { e.preventDefault(); if (currentPage > 1) handlePageChange(currentPage - 1); }}>
                            Previous
                        </Link>
                    </li>
                    {generatePageNumbers().map((page, index, array) => (
                        <li key={index}
                            className={`page-item ${page === currentPage ? 'active' : 'cursor-pointer'}  ${index > 0 && page - array[index - 1] > 1 ? 'disabled' : ''}`}>
                            {index > 0 && page - array[index - 1] > 1 ? renderDots() :
                                <Link to="#" className="page-link" onClick={(e) => { e.preventDefault(); handlePageChange(page); }}>
                                    {page}
                                </Link>}
                        </li>
                    ))}
                    <li className={`page-item ${currentPage >= pageCount ? 'disabled' : ''}`}>
                        <Link to="#" className="page-link" onClick={(e) => { e.preventDefault(); if (currentPage < pageCount) handlePageChange(currentPage + 1); }}>
                            Next
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default CustomPagination;
